export const accountLink = {
  created: 1664536611,
  expires_at: 1664536911,
  object: 'account_link',
  url: 'https://connect.stripe.com/setup/c/acct_1LmKQpQKILVC4wUm/4V58aRgFNWUJ',
};
